// Home
import {NavLink, Link} from 'react-router-dom';
import Hashtags from '../components/Hashtags';
import SocialMedia from '../components/SocialMedia';
import {ReactComponent as Hello} from '../media/graphics/hello.svg';
import works from "../data/works";

const Home = () => {

    let featuredWork = works[0];    

    return (
       
        <main className="home">
            
            <section className="home-intro">
                <Hello className="hello"/>
                <h1 className="name"><span className="name-dark"><span className="i-am">I'm </span>Kirsten </span><span className="name-light">Kwan.</span></h1>

                <h2 className="side-text">Portfolio</h2>

                <Hashtags />

                <div className="hidden">
                    <Hashtags />
                    <div className="quote">
                        <q>“Design doesn’t mean that every person [is] gonna like, love it, but that’s the creativity of [an] eye which creates something different.” 
                        <span>– Bijay Chhetri</span></q>
                    </div>
                </div>
                

                <nav className="home-intro-nav">
                    <ul>
                        <li><NavLink to="/work">Work</NavLink></li>
                        <li><NavLink to="/about">About</NavLink></li>
                        <li><NavLink to="/contact">Contact</NavLink></li>
                    </ul>
                </nav>

            </section>

            <section className="home-about">
                <div className="section-wrapper">
                    <h2 className="section-heading" >About</h2>
                    <p>I'm a front end web developer and web designer based in Vancouver, BC.</p>
                    <p>I create interactive and responsive websites that bring people to the fantasy.</p>
                    <Link to="/about" className="btn">More About Me</Link>
                </div>
                
            </section>

            <section className="home-work">
                <div className="section-wrapper">
                    <h2 className="section-heading">Featured Work</h2>

                    <article className="work-list">
                        <h4 className="work-type">{featuredWork.type}</h4>
                        <Link to={featuredWork.url}>
                            <img src={featuredWork.thumbnail} alt={featuredWork.title + " Mockup"} className="thumbnail" />
                        </Link>

                        <div className="work-info">
                            <Link to={featuredWork.url}><h3 className="work-title">{featuredWork.title}</h3></Link>
                            <p className="work-exerpt">{featuredWork.exerpt}</p>    

                            <Link to={featuredWork.url} className="btn">Learn More</Link>  
                        </div>
                                      
                    </article>
                </div>
                
            </section>

            <section className="home-contact">
                <div className="section-wrapper">
                    <h2 className="section-heading">Say Hi</h2>
                    <p>Have new ideas? Let's chat and connect!</p>
                    <Link to={"/contact"} className="btn">Connect</Link>
                    <SocialMedia />
                </div>
                
            </section>
        </main>

    );

}

export default Home;